import { useEffect, useLayoutEffect, useRef } from 'react';
import { setPopupPopstateGuard, silentGo } from './popstateGuard';

const getUrl = () => window.location.pathname + window.location.search + window.location.hash;

const makeId = () => `${Date.now().toString(16)}_${Math.random().toString(16).slice(2)}`;

export const useBlocker = (isActive: boolean, confirmAsync: () => Promise<boolean>) => {
  const idRef = useRef<string>(makeId());
  const activeRef = useRef(isActive);
  const confirmAsyncRef = useRef(confirmAsync);

  useEffect(() => {
    activeRef.current = isActive;
  }, [isActive]);

  useEffect(() => {
    confirmAsyncRef.current = confirmAsync;
  }, [confirmAsync]);

  useLayoutEffect(() => {
    const BLOCK_KEY = '__popupBlockerId';
    const history = window.history;

    const isTrap = () => {
      const s = (history.state ?? {}) as Record<string, any>;
      return s[BLOCK_KEY] === idRef.current;
    };

    const origReplace = history.replaceState.bind(history) as History['replaceState'];

    (history as any).replaceState = (state: any, title: string, url?: string | URL | null) => {
      const cur = (history.state ?? {}) as Record<string, any>;
      const curIsTrap = cur[BLOCK_KEY] === idRef.current;

      if (curIsTrap) {
        const next = { ...(state ?? {}), [BLOCK_KEY]: idRef.current };
        return origReplace(next, title, url as any);
      }

      return origReplace(state, title, url as any);
    };

    if (isActive) {
      if (!isTrap()) {
        const base = (history.state ?? {}) as Record<string, any>;
        history.pushState({ ...base, [BLOCK_KEY]: idRef.current }, '', getUrl());
      }

      setPopupPopstateGuard({
        enabled: () => activeRef.current,
        confirmAsync: () => confirmAsyncRef.current(),
      });
    } else {
      setPopupPopstateGuard(null);
    }

    return () => {
      setPopupPopstateGuard(null);
      (history as any).replaceState = origReplace;

      if (isTrap()) {
        silentGo(-1);
      }
    };
  }, [isActive]);
};
